import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2, ShieldCheck, TriangleAlert } from "lucide-react";
import { toast } from "sonner";
import { useAuth, formatApiError } from "../context/AuthContext";

export default function MagicLogin() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { magicLogin } = useAuth();
  const [error, setError] = useState("");
  const startedRef = useRef(false);

  useEffect(() => {
    // Il token è usa-e-getta: questa pagina deve provarlo UNA sola volta.
    // Evita doppie chiamate causate da rerender, StrictMode/cache o cambio stato auth.
    if (startedRef.current) return;
    startedRef.current = true;

    const token = params.get("token");
    if (!token) {
      setError("Token mancante. Rientra in gioco e usa /gestionale.");
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        await magicLogin(token);
        if (cancelled) return;
        setError("");
        toast.success("Accesso effettuato con Minecraft!");
        navigate("/", { replace: true });
      } catch (err) {
        if (cancelled) return;
        setError(formatApiError(err));
      }
    })();

    return () => { cancelled = true; };
  }, [params, magicLogin, navigate]);

  return (
    <div className="relative min-h-screen overflow-hidden flex items-center justify-center px-5">
      <div aria-hidden className="pointer-events-none fixed -top-40 -left-40 w-[480px] h-[480px] rounded-full blob blob-blue z-0" />
      <div aria-hidden className="pointer-events-none fixed top-40 -right-40 w-[520px] h-[520px] rounded-full blob blob-cyan z-0" />
      <div aria-hidden className="pointer-events-none fixed inset-0 grain z-0" />

      <div className="card-surface relative z-10 p-8 max-w-md w-full text-center">
        {error ? (
          <>
            <TriangleAlert className="w-12 h-12 mx-auto text-amber-300" />
            <h1 className="font-display text-3xl mt-4">Link non valido</h1>
            <p className="text-[hsl(var(--text-soft))] mt-3">{error}</p>
            <p className="text-sm text-[hsl(var(--text-mute))] mt-5">Torna in Minecraft e riesegui <b>/gestionale</b>.</p>
          </>
        ) : (
          <>
            <ShieldCheck className="w-12 h-12 mx-auto text-[hsl(var(--brand-300))]" />
            <h1 className="font-display text-3xl mt-4">Accesso in corso</h1>
            <p className="text-[hsl(var(--text-soft))] mt-3">Sto collegando il tuo account Minecraft al gestionale...</p>
            <Loader2 className="w-6 h-6 mx-auto mt-6 animate-spin text-[hsl(var(--brand-300))]" />
          </>
        )}
      </div>
    </div>
  );
}
